import { useTranslation } from 'react-i18next';

export default function Hero() {
  const { t } = useTranslation();

  return (
    <section className="relative w-full min-h-[520px] md:min-h-[650px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Elegant%20product%20photography%20flat%20lay%20composition%20featuring%20minimalist%20fashion%20accessories%20and%20sneakers%20arranged%20on%20warm%20cream%20toned%20textured%20surface%2C%20soft%20natural%20daylight%20from%20left%20window%20creating%20gentle%20highlights%20and%20subtle%20shadows%2C%20neutral%20beige%20sand%20and%20oatmeal%20color%20palette%2C%20Scandinavian%20aesthetic%2C%20one%20pair%20of%20clean%20white%20sneakers%20with%20premium%20leather%20texture%2C%20a%20modern%20watch%20with%20leather%20strap%2C%20a%20minimalist%20brown%20leather%20bag%2C%20delicately%20folded%20linen%20fabric%2C%20dried%20pampas%20grass%20in%20ceramic%20vase%2C%20editorial%20quality%20with%20airy%20spacious%20negative%20space%2C%20no%20text%20no%20logos%2C%20serene%20sophisticated%20atmosphere&width=1600&height=900&seq=kakobuy-hero-v2&orientation=landscape"
          alt="Kakobuy Spreadsheet Polska - Najlepsza baza produktów"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/10 to-black/30"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 lg:px-10 py-16 md:py-20 max-w-[1200px] mx-auto text-center">
        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-5 max-w-4xl mx-auto">
          {t('hero.title')}
        </h1>
        <p className="text-base md:text-lg text-white/80 max-w-2xl mx-auto mb-8 leading-relaxed">
          {t('hero.subtitle')}
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 md:gap-4 mb-10">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 text-background-50 font-semibold text-sm md:text-base rounded-full hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            {t('hero.cta1')}
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto px-8 py-3.5 bg-white/90 text-foreground-900 font-semibold text-sm md:text-base rounded-full hover:bg-white transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            {t('hero.cta2')}
          </a>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-3 md:gap-5">
          {[1, 2, 3, 4].map((i) => (
            <span key={i} className="flex items-center gap-1.5 text-white/70 text-xs md:text-sm">
              <span className="w-4 h-4 flex items-center justify-center text-accent-500">
                <i className="ri-check-line text-sm"></i>
              </span>
              {t(`hero.badge${i}`)}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}